export default __webpack_public_path__ + "media/images/icons_fc/help-29367af2ed527b2f71970642189e9558.png";